import React from 'react';

const Content: React.FC = ({ children }) => {
  return <div className="AppContent col-span-10">{children}</div>;
};

export default Content;
